import constants from "./constants";
import { t } from "../Utils/translate"

const allValidations = {
  email: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z ]{2,5})$/,
  email2:
    /^(?=.{0,64}@(\S))[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*[^-][A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{1,})(\S)$/,
  Numeric: /^[0-9]+$/,
  price: /^[0-9]+$/,
  version: /^[0-9][0-9.]*$/,
  username: /^[A-Za-z\s]{1,}[A-Za-z\s]{0,}$/,
  alphabets: /^[a-zA-Z ]*$/,
  alphaNumeric: /^[a-zA-Z0-9 ]*$/,
  digits: /^([+]?[0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[0-9])+$/,
  pattern: /^[0-9]+$/,
  doctorUsername:
    /^[a-zA-Z](?=.{7,20}$)(?:[a-zA-Z\d]+(?:(?:\.|-|_)[a-zA-Z\d])*)+$/,
  matchesLowerChar: /^[a-zA-Z]/,
  minLengthRegExp: /.{8,16}/,
  specialChars: /^[a-zA-Z0-9._-]+$/,
  specialtyName: /^(?=.*?[a-zA-Z])[a-zA-Z!@#$%^&*()-_=+~`[\]{}|;:'",.<>/?\\](?!.*?\d)[a-zA-Z!@#$%^&*()-_=+~`[\]{}|;:'",.<>/?\\]{6,19}$/,
  firstCharacterCapital: /^[^\W_].*/,
  character: /^[^0-9]+$/
};

function hciCodeValidator(hciCode) {
  let item = hciCode;
  if (item === "" || item == undefined || item == null) {
    return t("character");
  } else {
    return "";
  }
}

function reasonValidator(reason) {
  let item = reason;
  if (item === "" || item == undefined || item == null) {
    return t("character");
  } else if (!allValidations.alphabets.test(item)) {
    return t("character");
  }
}
function nameValidator(name) {
  let item = name;
  if (item === "" || item == null || item == undefined) {
    return {
      add: true,
      message: t("clinicNameIsEmpty"),
    };
  } else if (item.length < 3) {
    return {
      add: true,
      message: t("maxThree"),
    };
  } else if (item.length >= 100) {
    return {
      add: true,
      message: t("maxHundred"),
    };
  } else {
    return { add: true, message: "" };
  }
}

const passwordValidator = (password) => {
  let item = password;
  const uppercaseRegExp = /(?=.*?[A-Z])/;
  const lowercaseRegExp = /(?=.*?[a-z])/;
  const digitsRegExp = /(?=.*?[0-9])/;
  const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
  const minLengthRegExp = /.{8,16}/;
  if (item.length === 0 || item == "") {
    return {
      status: false,
      message: t("passwordEmpty"),
    };
  } else if (!uppercaseRegExp.test(item)) {
    return {
      status: false,
      message: t("uppercase"),
    };
  } else if (!lowercaseRegExp.test(item)) {
    return {
      status: false,
      message: t("lowercase"),
    };
  } else if (!digitsRegExp.test(item)) {
    return {
      status: false,
      message: t("digit"),
    };
  } else if (!specialCharRegExp.test(item)) {
    return {
      status: false,
      message: t("special"),
    };
  } else if (!minLengthRegExp.test(item)) {
    return {
      status: false,
      message: t("MaxEightChars"),
    };
  } else if (item.length > 15) {
    return {
      status: false,
      message: t("password"),
    };
  } else {
    return {
      status: true,
      message: "",
    };
  }
};

function userNameValidator(userName) {
  let item = userName;
  let username = /^[a-zA-Z0-9]+(?:[\/ -@#$%^&*!()_][a-zA-Z0-9]+)?$/;
  if (item === "" || item == null || item == undefined) {
    return {
      status: false,
      message: t("usernameEmpty"),
    };
  } else if (!username.test(item)) {
    return {
      status: false,
      message: t("specialMiddle"),
    };
  } else if (item.length < 6) {
    return {
      status: false,
      message: t("minSixChars"),
    };
  } else if (item.length > 19) {
    return {
      status: false,
      message: t("twentyChars"),
    };
  } else {
    return {
      status: true,
      message: "",
    };
  }
}

function registrationValidator(registration) {
  let item = registration;
  if (item === "" || item == null || item == undefined) {
    return t("emptyRegistrationField");
  } else {
    return "";
  }
}

function phoneValidator(phone, code) {

  const digitsRegExp = allValidations.digits;
  let item = phone;
  if (item == "" || item == null || item == undefined) {
    return {
      status: false,
      message: t("numberOnly"),
    };
  } else if (item.length === 0) {
    return {
      status: false,
      item: item,
      message: t("numberOnly"),
    };
  } else if (item[0] == 0) {
    return {
      status: false,
      item: item.slice(0, -1),
      message: t("zeroErr"),
    };
  } else if (!digitsRegExp.test(item)) {
    return {
      status: false,
      item: item.slice(0, -1),
      message: t("numberOnly"),
    };
  } else if ((code == "91" || code == "+91") && item.length < 10) {
    return {
      status: false,
      message: t("tenNumberOnly"),
    };
  } else if ((code == "65" || code == "+65") && item.length < 8) {
    return {
      status: false,
      message: t("eightNumberOnly"),
    };
  } else if (
    ((code !== "65" && code !== "91") || (code !== "65" && code !== "91")) &&
    item.length < 8
  ) {
    return {
      status: false,
      message: t("twelveErr"),
    };
  } else {
    return {
      item: item,
      message: "",
      status: true,
    };
  }
}

function phoneValidator1(phone, countryCode1) {
  let item = phone;
  const digitsRegExp = allValidations.digits;
  if (countryCode1 === constants.country.singapore && item.length > 8) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: "",
    };
  } else if (countryCode1 === constants.country.singapore && item.length > 9) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: t("onlyEightNumbers"),
    };
  } else if (countryCode1 === constants.country.india && item.length > 10) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: "",
    };
  } else if (countryCode1 === constants.country.india && item.length > 11) {
    item = item.slice(0, -1);
    return {
      status: true,
      message: t("onlyTenNumbers"),
    };
  } else if (
    countryCode1 !== constants.country.singapore &&
    countryCode1 !== constants.country.india &&
    item.length > 12
  ) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: "",
    };
  } else if (!digitsRegExp.test(item)) {
    return {
      status: false,
      message: t("numberOnly"),
    };
  } else {
    return "";
  }
}

function phoneValidator2(phone, countryCode1) {
  let item = phone;
  const digitsRegExp = allValidations.digits;
  if (!digitsRegExp.test(item)) {
    return t("invalidNumber");
  } else if (countryCode1 === constants.country.singapore && item.length > 8) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: t("onlyEightNumbers"),
    };
  } else if (countryCode1 === constants.country.singapore && item.length > 9) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: t("onlyEightNumbers"),
    };
  } else if (countryCode1 === constants.country.india && item.length > 10) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: t("onlyTenNumbers"),
    };
  } else if (countryCode1 === constants.country.india && item.length > 11) {
    item = item.slice(0, -1);
    return {
      status: true,
      message: t("onlyTenNumbers"),
    };
  } else if (
    countryCode1 !== constants.country.singapore &&
    countryCode1 !== constants.country.india &&
    item.length > 12
  ) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: "",
    };
  } else {
    return "";
  }
}

function phoneValidator3(phone, countryCode1) {
  let item = phone;
  const digitsRegExp = allValidations.digits;
  if (!digitsRegExp.test(item)) {
    return t("invalidNumber");
  } else if (countryCode1 === constants.country.singapore && item.length > 8) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: t("onlyEightNumbers"),
    };
  } else if (countryCode1 === constants.country.singapore && item.length > 9) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: t("onlyEightNumbers"),
    };
  } else if (countryCode1 === constants.country.india && item.length > 10) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: t("onlyTenNumbers"),
    };
  } else if (countryCode1 === constants.country.india && item.length > 11) {
    item = item.slice(0, -1);
    return {
      status: true,
      message: t("onlyTenNumbers"),
    };
  } else if (
    countryCode1 !== constants.country.singapore &&
    countryCode1 !== constants.country.india &&
    item.length > 12
  ) {
    item = item.slice(0, -1);
    return {
      status: false,
      message: "",
    };
  } else {
    return "";
  }
}

function emailValidator(email) {
  let item = email;
  var pattern = allValidations.email2;
  if (item === "" || item == null || item == undefined) {
    return t("emptyEmailId");
  } else if (!pattern.test(item)) {
    item.slice(0, -1);
    return t("invalidEmail");
  } else {
    return "";
  }
}

function clinicAddressValidator(clinicAddress, t) {
  let item = clinicAddress;
  if (item === "" || item == null || item == undefined) {
    return {
      add: true,
      message: t("emptyClinicAddress"),
    };
  } else if (item.length < 3) {
    return {
      add: true,
      message: t("maxThree"),
    };
  } else if (item.length > 999) {
    return {
      add: false,
      message: t("maxchar"),
    };
  } else {
    return {
      add: true,
      message: "",
    };
  }
}
function zipCodeValidator(zipCode, t) {
  let item = zipCode;
  var pattern = allValidations.pattern;
  if (item === "") {
    return t("zipCodeErr");
  } else if (!pattern.test(item)) {
    return t("numberOnly");
  } else {
    return "";
  }
}

const NumericValidator = (value) => {
  if (!allValidations.price.test(value)) {
    return t("numberOnly");
  } else {
    return "";
  }
};

const doctorUsernameValidator = (item) => {
  if (!allValidations.matchesLowerChar.test(item)) {
    return {
      status: false,
      message: t("startWithLetter"),
    };
  } else if (!allValidations.minLengthRegExp.test(item)) {
    return {
      status: false,
      message: t("MaxEightChars"),
    };
  } else if (!allValidations.specialChars.test(item)) {
    return {
      status: false,
      message: t("allowedChars"),
    };
  } else if (!allValidations.doctorUsername.test(item)) {
    return {
      status: false,
      message: t("specialChars"),
    };
  } else {
    return {
      status: true,
      message: "",
    };
  }
};

function doctorNameValidator(name) {
  let item = name;
  if (item === "" || item == null || item == undefined) {
    return {
      add: true,
      message: t("doctorNameIsEmpty"),
    };
  } else {
    return { add: true, message: "" };
  }
}

function qualificationValidator(name) {
  let item = name;
  if (item === "" || item == null || item == undefined) {
    return {
      add: true,
      message: t("qualificationIsEmpty"),
    };
  } else {
    return { add: true, message: "" };
  }
}

function mcrValidator(name) {
  let item = name;
  if (item === "" || item == null || item == undefined) {
    return {
      add: true,
      message: t("doctorMCRIsEmpty"),
    };
  } else {
    return { add: true, message: "" };
  }
}

function specialtyNameValidator(item) {
  if (item === "" || item == null || item == undefined) {
    return t("specialityNameIsEmpty")
  } else if (!allValidations.firstCharacterCapital.test(item)) {
    return t("specialNotAllowed")
  } else if (!allValidations.character.test(item)) {
    return t("numberNotAllowed")
  } else {
    return ""
  }
}

const validations = {
  allValidations,
  phoneValidator,
  nameValidator,
  registrationValidator,
  emailValidator,
  clinicAddressValidator,
  zipCodeValidator,
  phoneValidator1,
  phoneValidator2,
  phoneValidator3,
  userNameValidator,
  passwordValidator,
  NumericValidator,
  hciCodeValidator,
  doctorUsernameValidator,
  doctorNameValidator,
  qualificationValidator,
  mcrValidator,
  specialtyNameValidator
};

export default validations;
